import React from "react";
import logo from "../../assest/logo.svg";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <div className="container">
      <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 gap-3">
        <p className="col-md-4 mb-0 text-white">
          © {year} VoltHertz Technologies Pvt Ltd
        </p>
        <a href="#home" className="col-md-4 d-flex justify-content-center">
          <div className="border border-white p-1 bg-white rounded">
            <img src={logo} alt="VoltHertz Technologies Pvt Ltd" />
          </div>
        </a>

        <ul className="nav col-md-4 justify-content-end">
          <li className="nav-item">
            <a href="#home" className="nav-link px-2 text-white">
              Home
            </a>
          </li>
          <li className="nav-item">
            <a href="#services" className="nav-link px-2 text-white">
              Services
            </a>
          </li>

          <li className="nav-item">
            <a href="#about" className="nav-link px-2 text-white">
              About Us
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" className="nav-link px-2 text-white">
              Contact Us
            </a>
          </li>
        </ul>
      </footer>
    </div>
  );
};

export default Footer;
